import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from '@ls/react-date-picker';

import { setSelectedAsOfDate, setSymbolicDate } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import {
  selectSelectedAsOfDate,
  selectSymbolicDate
} from 'state/selections/selectors';

const AsOfDatePicker = () => {
  const dispatch = useDispatch();
  const onChange = useCallback(
    asOfDate => dispatch(setSelectedAsOfDate(asOfDate)),
    [dispatch]
  );
  const selected = useSelector(
    selectSelectedAsOfDate(SelectionState.UNCOMMITTED)
  );
  const symbolicDate = useSelector(
    selectSymbolicDate(SelectionState.UNCOMMITTED)
  );
  const onChangeSymbolicDate = useCallback(
    value => dispatch(setSymbolicDate(value)),
    [dispatch]
  );
  return (
    <DatePicker
      onChange={onChange}
      selected={selected}
      onChangeSymbolicDate={onChangeSymbolicDate}
      symbolicDate={symbolicDate}
      variation={1}
      label="End Date"
      enableQuickSelect
      quickSelectButtons= {['PMS12','PYS','PYE', 'CYS','PQS','PQE', 'CQS','PMS','PME','CMS', 'PBD', 'CBD']}
      showMonthDropdown
      showYearDropdown
    
    />
  );
};

export default AsOfDatePicker;
